import { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import ModalContext from "components/contexts/ModalContext";
import client from "api/WookAxios";
import { naver, kakao, google, authorize } from "auth/DeprecatedOAuth";
import naverOAuth from "images/naverLogoButton.png";
import kakaoOAuth from "images/kakao_oauth_large.png";
import googleOAuth from "images/google_oauth.svg";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useAuth } from "auth/useAuth";
import { FaLess } from "react-icons/fa";
import UserContext from "user/UserContext";
import log, { error } from "loglevel";
import { CONFIG } from "config";
import { API_PATHS } from "constants/api";
import { OAUTH_PROVIDERS, OAUTH_PROVIDERS_KOREAN } from "constants/provider";
import { parseErrors } from "lib/errors/parse";
import { toast } from "sonner";
import { REGISTER_TOKEN } from "constants/auth";
import { REGISTER_PAGE } from "auth/register/constants";

const ModalFrame = styled.div`
  // display: ${(props) => (props.$visible ? "flex" : "none")};
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgb(45, 49, 45, 0.5);
  z-index: 1010;
`;

const Modal = styled.div`
  box-sizing: border-box;
  position: relative;
  top: 80px;
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  align-items: center;
  border-radius: 20px;
  width: 350px;
  height: 420px;
  margin: 0 auto;
  background: #fafbfa;
  background: white;
  opacity: 1;
`;

const Title = styled.div`
  // height: 40px;
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 35px;
  font-weight: 500;
  color: #464646;
  padding-top: 10px;
  padding-left: 10px;
`;

const SubTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-right: 20px;
  font-size: 15px;
  // background: red;
  margin-top: 5px;
  color: green;
`;

const StyledForm = styled.form`
  width: 280px;
  padding: 15px 0;
  // background: red;
`;

const StyledInput = styled.input`
  width: 98.5%;
  height: 35px;
  box-sizing: border-box;
  border-radius: 4px;
  border: none;
  margin-bottom: 10px;
  background: #eeeeee;

  // outline: none;

  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;

  &::placeholder {
    // color: #black;
    color: ${(props) => (props.$error ? 'LightCoral': '#black')};
  }

  &:focus {
    color: black;
  }
`;

const StyledSubmit = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: none;
  background: pink;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;
`;

const Providers = styled.div`
  width: 280px;
  padding-top: 20px;
  // background: blue;
`;

const Provider = styled.div`
  display: flex;
  justify-content: left;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  margin: 5px 0px;
  background: white;
  cursor: pointer;
  // border: 0.3px gray solid;
`;

const Topic = styled.label`
  // color: blue;
  color: ${props => props.$disabled ? 'gray' : 'blue'};
`;

const TopicError = styled.label`
  color: red;
  margin-left: 10px;
`;

const StatusBar = styled.div`
  box-sizing: border-box;  
  width: 280px;
  padding-top: 12px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: flex-end;
  // background: red;
`;

const TextButton = styled.div`
  color: red;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  &:hover {
    background: lightgray;
  }
`;

const OAuthCompleteModal = ({ registerData, pendingData, setRegisterData, onSuccess, onFailure }) => {
  const [provider, setProvider] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  
  useEffect(() => {
    completeOAuth();
  }, []);

  const completeOAuth = async () => {
    setProvider(pendingData.provider);
    setRegisterData(prev => ({
      ...prev,
      name: pendingData.name,
      email: pendingData.email,
      mobile: pendingData.mobile,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!registerData.name) {
      setFieldErrors(prev => ({...prev, name: '(필수 입력)'}));
      return;
    }

    if (!registerData.email) {
      setFieldErrors(prev => ({...prev, email: '(필수 입력)'}));
      return;
    }

    if (!registerData.mobile) {
      setFieldErrors(prev => ({...prev, mobile: '(필수 입력)'}));
      return;
    }
    
    onSuccess();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRegisterData(prev => ({...prev, [name]: value}));
  };
  
  const handleClose = () => {
    onFailure();
  };

  const onTest = () => {
    // document.querySelector('.OAuthCompleteModal input[name="mobile"]').value = '010-1111-2222';
    setRegisterData(prev => ({...prev, mobile: '010-1111-2222'}));
  };

  return (
    <div className="OAuthCompleteModal">
      <ModalFrame>
        <Modal>
          <Title>{OAUTH_PROVIDERS_KOREAN[provider]}로 회원가입</Title>
          <SubTitle>아래 정보를 확인하고 입력,수정해 주세요</SubTitle>
          <StyledForm onSubmit={handleSubmit}>            
            <Topic>이름</Topic><TopicError>{fieldErrors?.name}</TopicError>
            <StyledInput name="name" value={registerData.name} onChange={handleInputChange} />
            <Topic>이메일</Topic><TopicError>{fieldErrors?.email}</TopicError>
            <StyledInput name="email" value={registerData.email} onChange={handleInputChange} />
            <Topic>전화번호</Topic><TopicError>{fieldErrors?.mobile}</TopicError>
            <StyledInput name="mobile" value={registerData.mobile} onChange={handleInputChange} />
            <StyledSubmit type="submit" value="다음" />
          </StyledForm>
          <StatusBar>
            {process.env.NODE_ENV === 'development' &&
              <button onClick={onTest} style={{ marginRight: '60px' }}>mobile</button>
            }
            <TextButton onClick={handleClose}>뒤로</TextButton>
          </StatusBar>
        </Modal>
      </ModalFrame>
    </div>
  );
};

export default OAuthCompleteModal;
